import { useLocalStorage } from '@rehooks/local-storage'

import { TableIds } from '../../../enums/tableIds'

export const REVIEW_ENTRIES_HIDDEN_COLUMNS_STORAGE_KEY = `ds-column-visibility-${TableIds.ReviewEntries}`

export const useReviewEntriesHiddenColumns = () =>
  useLocalStorage<string[]>(REVIEW_ENTRIES_HIDDEN_COLUMNS_STORAGE_KEY, [])
